import { useEffect } from 'react';

import { useGetUser } from '@/shared/modules/auth/hooks/useGetUser';

import { getRum } from './apm';

export const useApmUserContext = () => {
  const { data } = useGetUser();

  useEffect(() => {
    if (data?.id) {
      // APM is internal ops telemetry — raw id is intentional.
      // EBT (external telemetry) hashes the id with sha256 in EbtAnalytics.registerUserIdContext.
      getRum()?.setUserContext({ id: String(data.id) });
    }
  }, [data?.id]);
};
